import Layout from '@/components/Layout';
import { LINK, PATH } from '@/constants';
import useConfirmationNavigate from '@/hooks/useConfirmationNavigate';
import { useGetLanguagesQuery } from '@/redux/api/api.caller';
import { tokenSelector } from '@/redux/features/auth.slice';
import { BlockStack, Button, SkeletonBodyText } from '@shopify/polaris';
import { ArrowLeftIcon, ViewIcon } from '@shopify/polaris-icons';
import { useSelector } from 'react-redux';
import LanguageSettingsCard from './components/LanguageSettingsCard';
import LanguageUpgradeBanner from './components/LanguageUpgradeBanner';
import LanguagesTable from './components/LanguagesTable';
import useTrackingPageUrl from '@/hooks/useTrackingPageUrl';

const LanguagesPage = () => {
  const navigate = useConfirmationNavigate();
  const { shop } = useSelector(tokenSelector);
  const { proxyPath } = useTrackingPageUrl();
  const { data, isLoading } = useGetLanguagesQuery();
  const list = data?.data;

  return (
    <Layout
      title={
        (
          <div className="d-flex align-center">
            <Button variant="plain" onClick={() => navigate(PATH.TRACKING_PAGE)} icon={ArrowLeftIcon} />
            <span className="ml-4 d-inline-block">Languages</span>
          </div>
        ) as any
      }
      secondaryActions={
        <div style={{ display: 'flex', gap: 8, flexWrap: 'nowrap', flexShrink: 0 }}>
          <Button icon={ViewIcon} url={LINK.CUSTOMER_SHOP(shop, proxyPath)} external>
            Preview tracking page
          </Button>
        </div>
      }
    >
      {isLoading || !list ? (
        <SkeletonBodyText lines={10} />
      ) : (
        <BlockStack gap="400">
          <LanguageUpgradeBanner list={list} />
          <LanguagesTable list={list} />
          <LanguageSettingsCard list={list} />
        </BlockStack>
      )}
    </Layout>
  );
};

export default LanguagesPage;
